/**
 * @module UI/Utilities/Helpers
 * @desc Helpers helper funtions
 */

import { formatNumber } from '../strings/format-number';

/**
 * Return whatsapp link
 */

export function getWhatsAppLink(phone = '', isMobile = false, text = 'Iniciar atendimento') {
  return `https://${isMobile ? 'api' : 'web'}.whatsapp.com/send?phone=55${formatNumber(
    phone,
  )}&text=${encodeURIComponent(text)}`;
}
